import React, { useState, useEffect, useCallback, useMemo } from "react";
import {
  Plus,
  Trash2,
  Box,
  X,
  UploadCloud,
  ShieldCheck,
  Tag,
  Info,
  Layers,
  Truck,
  Search,
  ChevronLeft,
  ChevronRight,
  Loader2,
  Filter,
  Edit3,
  Package,
  Star,
  Edit,
} from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { http } from "../../axios/axios";
import { toast } from "react-toastify";
import { useDebounce } from "../../hooks/useDebounce";
import StatCard from "../../component/StatCard";
import AdminHeader from "../../component/AdminHeader";
import { FormInput, FormSelect, FormTextArea } from "../../helpers/AdminHelper";
import { GetImageUrl } from "../../helpers/GetImageUrl";
import ActionButtons from "../../component/AdminActionButtons";
import ProductImagesSection from "./AdminProductComponent/ProductImagesSection";
import ProductPdfSection from "./AdminProductComponent/ProductPdfSection";

function CreateProduct({
  handleSubmit,
  images,
  setImages,
  pdfs,
  setPdfs,
  closeModal,
  setProductForm,
  productForm,
  brands,
  ipNetworkBrands,
  categories,
  subCategories,
  ipNetworkCategories,
  ipNetworkSubCategories,
  handleCategoryChange,
  handleIpNetworkCategoryChange,
  loadingSub,
  lockedCatalogType,
}) {
  const inputClass =
    "w-full border border-white/10 bg-white/5 text-white px-4 py-3 rounded-xl mt-2 outline-none focus:border-blue-500 transition";

  const warrantyOptions = useMemo(
    () => [
      {
        value: "Month",
        label: "Month",
      },
      {
        value: "Year",
        label: "Year",
      },
    ],
    [],
  );

  const brandOptions = useMemo(() => {
    return brands.map((brand) => ({
      value: brand._id,
      label: brand.brandName,
    }));
  }, [brands]);

  const ipNetworkBrandOptions = useMemo(() => {
    return ipNetworkBrands.map((brand) => ({
      value: brand._id,
      label: brand.brandName,
    }));
  }, [ipNetworkBrands]);

  const categoryOptions = useMemo(() => {
    return categories.map((category) => ({
      value: category._id,
      label: category.name,
    }));
  }, [categories]);

  const subCategoryOptions = useMemo(() => {
    return subCategories.map((sub) => ({
      value: sub._id,
      label: sub.name,
    }));
  }, [subCategories]);

  const ipNetworkCategoryOptions = useMemo(
    () => ipNetworkCategories.map((item) => ({ value: item._id, label: item.name })),
    [ipNetworkCategories],
  );

  const ipNetworkSubCategoryOptions = useMemo(
    () => ipNetworkSubCategories.map((item) => ({ value: item._id, label: item.name })),
    [ipNetworkSubCategories],
  );

  const handleFieldChange = useCallback((field, value) => {
    setProductForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  });
  {
    /** Features Handlers */
  }
  const addFeature = () => {
    setProductForm((prev) => ({
      ...prev,
      features: [...prev.features, ""],
    }));
  };

  const removeFeature = (index) => {
    setProductForm((prev) => ({
      ...prev,
      features: prev.features.filter((_, i) => i !== index),
    }));
  };

  const updateFeature = (index, value) => {
    setProductForm((prev) => ({
      ...prev,
      features: prev.features.map((item, i) => (i === index ? value : item)),
    }));
  };

  {
    /** Youtube Link Handlers */
  }
  const addYoutubeLink = () => {
    if (productForm.youtubeLink.length >= 10) {
      toast.warning("Maximum 10 YouTube links allowed");
      return;
    }

    setProductForm((prev) => ({
      ...prev,
      youtubeLink: [...prev.youtubeLink, ""],
    }));
  };

  const removeYoutubeLink = (index) => {
    setProductForm((prev) => ({
      ...prev,
      youtubeLink: prev.youtubeLink.filter((_, i) => i !== index),
    }));
  };

  const updateYoutubeLink = (index, value) => {
    setProductForm((prev) => ({
      ...prev,
      youtubeLink: prev.youtubeLink.map((item, i) =>
        i === index ? value : item,
      ),
    }));
  };

  {
    /** Specifications Handlers */
  }
  const addSpecification = () => {
    setProductForm((prev) => ({
      ...prev,
      specifications: [
        ...prev.specifications,
        {
          title: "",
          details: "",
        },
      ],
    }));
  };

  const removeSpecification = (index) => {
    setProductForm((prev) => ({
      ...prev,
      specifications: prev.specifications.filter((_, i) => i !== index),
    }));
  };

  const updateSpecification = (index, field, value) => {
    setProductForm((prev) => ({
      ...prev,
      specifications: prev.specifications.map((item, i) =>
        i === index
          ? {
              ...item,
              [field]: value,
            }
          : item,
      ),
    }));
  };

  return (
    <motion.div className="fixed inset-0 bg-black/90 backdrop-blur-xl z-50">
      <motion.div
        className="fixed z-50 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2
        w-[95%]
        h-[90vh]
        bg-[#0a0f1a]
        border border-white/10
        rounded-2xl
        shadow-2xl
        overflow-hidden
        flex flex-col 
        "
      >
        <div
          className="
          flex items-center justify-between
          p-4 md:px-8 
          border-b border-white/10
          bg-white/[0.03]
          "
        >
          <div>
            <h3 className="text-lg md:text-xl lg:text-2xl font-black text-white uppercase">
              Create Product{" "}
            </h3>
            <p className="text-sm md:text-lg lg:text-xl">
              Add Product details and Images{" "}
            </p>
          </div>
          <button
            type="button"
            onClick={closeModal}
            className="h-10 w-10 rounded-xl bg-white/5 
          hover:bg-red-500 text-slate-300 flex items-center justify-center 
          "
          >
            <X size={20} />
          </button>
        </div>

        <form
          onSubmit={handleSubmit}
          className="p-4 md:p-8 space-y-6 overflow-y-auto flex-1"
        >
          <ProductImagesSection images={images} setImages={setImages} />

          <div className="my-6 border-t border-white/10" />

          <ProductPdfSection pdfs={pdfs} setPdfs={setPdfs} />

          <div className="my-6 border-t border-white/10" />

          {/* Youtube Link */}
          <div className="space-y-5">
            <div className="flex justify-between items-center">
              <h3 className="text-white text-sm font-bold uppercase">
                Product Youtube Links
              </h3>

              <button
                type="button"
                onClick={addYoutubeLink}
                className={`
    px-4 py-2
    rounded-xl
    border
    text-xs
    cursor-pointer
    ${
      productForm?.youtubeLink.length >= 10
        ? "opacity-40 cursor-not-allowed border-white/10"
        : "bg-blue-500/10 border-blue-500/30 text-blue-400"
    }
  `}
              >
                + Add Youtube Link
              </button>
            </div>

            {productForm.youtubeLink.length > 0 &&
              productForm.youtubeLink.map((link, index) => (
                <div key={index} className="flex gap-3 items-end">
                  <div className="flex-1">
                    <FormInput
                      label={`Youtube Link ${index + 1}`}
                      className={inputClass}
                      placeholder="Paste Product Youtube Link"
                      value={link}
                      onChange={(e) => updateYoutubeLink(index, e.target.value)}
                    />
                  </div>

                  {productForm.youtubeLink.length > 1 && (
                    <button
                      type="button"
                      onClick={() => removeYoutubeLink(index)}
                      className="
        bg-red-500
        px-4
        py-3
        rounded-xl
        text-white
        h-fit
      "
                    >
                      Remove
                    </button>
                  )}
                </div>
              ))}
          </div>

          <div className="my-6 border-t border-white/10" />

          {/* Trending Product */}
          <div className="flex items-center justify-between bg-white/5 border border-white/10 rounded-xl px-4 py-3 space-y-4">
            <div>
              <p className="text-white font-semibold text-sm">
                Trending Product
              </p>
              <p className="text-xs text-slate-400">
                Show this product as trending
              </p>
            </div>

            <button
              type="button"
              onClick={() =>
                handleFieldChange("isTrending", !productForm.isTrending)
              }
              className={`
      w-14 h-7 rounded-full p-1 transition
      ${productForm.isTrending ? "bg-blue-600" : "bg-gray-600"}
    `}
            >
              <div
                className={`
        w-5 h-5 rounded-full bg-white transition-transform
        ${productForm.isTrending ? "translate-x-7" : "translate-x-0"}
      `}
              />
            </button>
          </div>

          <div className="my-6 border-t border-white/10" />

          <div className="space-y-5">
            <FormInput
              label="Asset ID"
              className={inputClass}
              placeholder="CP-001"
              value={productForm.assetId}
              onChange={(e) => handleFieldChange("assetId", e.target.value)}
            />
          </div>

          <div className="space-y-5">
            <FormInput
              label="Title"
              className={inputClass}
              placeholder="CP Plus Camera"
              value={productForm.title}
              onChange={(e) => handleFieldChange("title", e.target.value)}
            />
          </div>

          {!lockedCatalogType && (
            <FormSelect
              label="Product Catalog"
              className={inputClass}
              value={productForm.catalogType}
              onChange={(e) => handleFieldChange("catalogType", e.target.value)}
              options={[
                { value: "catalog", label: "Catalog" },
                { value: "ip-network", label: "IP Networks" },
              ]}
            />
          )}

          {/* Brand Category Sub Category */}
          <div className="grid grid-cols-1  lg:grid-cols-3 gap-5 w-full">
            {productForm.catalogType === "ip-network" ? (
              <FormSelect
                label="IT Product Brand"
                className={inputClass}
                value={productForm.ipNetworkBrand}
                onChange={(e) => handleFieldChange("ipNetworkBrand", e.target.value)}
                placeholder="Select IT Product Brand"
                options={ipNetworkBrandOptions}
              />
            ) : (
              <FormSelect
                label="Brand"
                className={inputClass}
                value={productForm.brand}
                onChange={(e) => handleFieldChange("brand", e.target.value)}
                placeholder="Select Brand"
                options={brandOptions}
              />
            )}

            {productForm.catalogType === "ip-network" ? (
              <>
                <FormSelect
                  label="IT Product Category"
                  className={inputClass}
                  value={productForm.ipNetworkCategory}
                  onChange={(e) => handleIpNetworkCategoryChange(e.target.value)}
                  placeholder="Select IT Product Category"
                  options={ipNetworkCategoryOptions}
                />
                <FormSelect
                  label="IT Product Sub Category"
                  className={inputClass}
                  disabled={loadingSub}
                  value={productForm.ipNetworkSubCategory}
                  onChange={(e) => handleFieldChange("ipNetworkSubCategory", e.target.value)}
                  placeholder={loadingSub ? "Loading..." : "Select IT Product Sub Category"}
                  options={ipNetworkSubCategoryOptions}
                />
              </>
            ) : (
              <>
                <FormSelect
                  label="Category"
                  className={inputClass}
                  value={productForm.category}
                  onChange={(e) => handleCategoryChange(e.target.value)}
                  placeholder="Select Category"
                  options={categoryOptions}
                />
                <FormSelect
                  label="Sub Category"
                  className={inputClass}
                  disabled={loadingSub}
                  value={productForm.subCategory}
                  onChange={(e) => handleFieldChange("subCategory", e.target.value)}
                  placeholder={loadingSub ? "Loading..." : "Select Sub Category"}
                  options={subCategoryOptions}
                />
              </>
            )}
          </div>

          {/* Pricing */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            <FormInput
              label="Base Price"
              className={inputClass}
              type="number"
              placeholder="Enter base price"
              value={productForm.priceBase}
              onChange={(e) => handleFieldChange("priceBase", e.target.value)}
            />

            <FormInput
              label="Discounted Price"
              className={inputClass}
              type="number"
              placeholder="Enter discounted price"
              value={productForm.discountedPrice}
              onChange={(e) =>
                handleFieldChange("discountedPrice", e.target.value)
              }
            />

            <FormInput
              label="Reselling Price"
              className={inputClass}
              type="number"
              placeholder="Enter reselling price"
              value={productForm.resellingPrice}
              onChange={(e) =>
                handleFieldChange("resellingPrice", e.target.value)
              }
            />

            <FormInput
              label="GST Percentage"
              className={inputClass}
              type="number"
              placeholder="18"
              value={productForm.gstPercentage}
              onChange={(e) =>
                handleFieldChange("gstPercentage", e.target.value)
              }
            />
          </div>

          {/* Warranty */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
            <FormInput
              label="Warranty Duration"
              className={inputClass}
              type="number"
              placeholder="Enter warranty duration"
              value={productForm.warrantyDuration}
              onChange={(e) =>
                handleFieldChange("warrantyDuration", e.target.value)
              }
            />

            <FormSelect
              label="Warranty Unit"
              className={inputClass}
              value={productForm.warrantyUnit}
              onChange={(e) =>
                handleFieldChange("warrantyUnit", e.target.value)
              }
              options={warrantyOptions}
            />
            <FormSelect
              label="Product Status"
              className={inputClass}
              value={productForm.status}
              onChange={(e) => handleFieldChange("status", e.target.value)}
              placeholder="Select Status"
              options={[
                {
                  value: "published",
                  label: "Publish",
                },
                {
                  value: "draft",
                  label: "Save as Draft",
                },
              ]}
            />
          </div>

          <div className="space-y-5">
            <FormTextArea
              label="Product Description"
              className={inputClass}
              rows={5}
              placeholder="Write product description..."
              value={productForm.description}
              onChange={(e) => handleFieldChange("description", e.target.value)}
            />
          </div>

          <div className="my-6 border-t border-white/10" />

          {/* Feature */}
          <div className="space-y-5">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
              <h3 className="text-white font-bold text-lg">Features</h3>

              <button
                type="button"
                onClick={addFeature}
                className="w-full sm:w-auto rounded-xl bg-blue-600 px-4 py-2 text-white transition hover:bg-blue-700"
              >
                + Add Feature
              </button>
            </div>

            {productForm.features.map((feature, index) => (
              <div key={index} className="flex gap-3 items-end">
                <div className="flex-1">
                  <FormInput
                    label={`Feature ${index + 1}`}
                    className={inputClass}
                    placeholder="Enter feature"
                    value={feature}
                    onChange={(e) => updateFeature(index, e.target.value)}
                  />
                </div>

                {productForm.features.length > 1 && (
                  <button
                    type="button"
                    onClick={() => removeFeature(index)}
                    className="
        bg-red-500
        px-4
        py-3
        rounded-xl
        text-white
        h-fit
      "
                  >
                    Remove
                  </button>
                )}
              </div>
            ))}
          </div>

          <div className="my-6 border-t border-white/10" />

          {/* Specifications */}
          <div className="space-y-4 mt-6">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
              <h3 className="text-white font-bold text-lg">Specifications</h3>

              <button
                type="button"
                onClick={addSpecification}
                className="
      w-full sm:w-auto
      px-4 py-2
      rounded-xl
      bg-blue-600
      text-white
      transition
      hover:bg-blue-700
    "
              >
                + Add Specifications
              </button>
            </div>

            {productForm.specifications.map((spec, index) => (
              <div
                key={index}
                className="
        border border-white/10
        bg-white/5
        p-3
        rounded-xl
      space-y-4
      "
              >
                <FormInput
                  label="Title"
                  className={inputClass}
                  placeholder="RAM"
                  value={spec.title}
                  onChange={(e) =>
                    updateSpecification(index, "title", e.target.value)
                  }
                />

                <FormTextArea
                  label="Details"
                  rows={2}
                  className={inputClass}
                  placeholder="8GB DDR4 RAM"
                  value={spec.details}
                  onChange={(e) =>
                    updateSpecification(index, "details", e.target.value)
                  }
                />

                {productForm.specifications.length > 1 && (
                  <button
                    type="button"
                    onClick={() => removeSpecification(index)}
                    className="
            bg-red-500
            px-3
            py-1.5
            text-sm
            rounded-lg
            text-white
          "
                  >
                    Remove
                  </button>
                )}
              </div>
            ))}
          </div>

          <div className="my-6 border-t border-white/10" />
          {/* Meta */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            <FormInput
              label="Slug"
              className={inputClass}
              placeholder="product-slug"
              value={productForm.slug}
              onChange={(e) => handleFieldChange("slug", e.target.value)}
            />

            <FormInput
              label="Meta Title"
              className={inputClass}
              placeholder="Enter meta title"
              value={productForm.metaTitle}
              onChange={(e) => handleFieldChange("metaTitle", e.target.value)}
            />
          </div>
          <div className="space-y-5">
            <FormTextArea
              label="Meta Description"
              className={inputClass}
              rows={4}
              placeholder="Enter meta description for SEO"
              value={productForm.metaDescription}
              onChange={(e) =>
                handleFieldChange("metaDescription", e.target.value)
              }
            />
          </div>
          <div className="space-y-5">
            <FormInput
              label="Meta Tags"
              className={inputClass}
              placeholder="camera, security, cctv"
              value={productForm.metaTags}
              onChange={(e) => handleFieldChange("metaTags", e.target.value)}
              helperText="Separate tags with commas"
            />
          </div>
          <div className="space-y-5">
            <FormTextArea
              label="Schema Script"
              className={inputClass}
              rows={6}
              placeholder={`{
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Product Name"
}`}
              value={productForm.schemaScript}
              onChange={(e) =>
                handleFieldChange("schemaScript", e.target.value)
              }
            />
          </div>
          <div
            className="
    flex flex-col-reverse sm:flex-row
    sm:justify-end
    gap-3
    pt-5
    border-t border-white/10
  "
          >
            <button
              type="button"
              onClick={closeModal}
              className="
      w-full sm:w-auto
      px-6 py-3
      rounded-xl
      bg-white/5
      hover:bg-white/10
      transition
    "
            >
              Cancel
            </button>

            <button
              type="submit"
              className="
      w-full sm:w-auto
      px-6 py-3
      rounded-xl
      bg-blue-600
      hover:bg-blue-700
      text-white
      transition
    "
            >
              Create Products
            </button>
          </div>
        </form>
      </motion.div>
    </motion.div>
  );
}

const AdminProducts = ({ catalogType: lockedCatalogType } = {}) => {
  const getInitialProductForm = () => ({
    assetId: "",
    title: "",
    brand: "",
    ipNetworkBrand: "",
    catalogType: lockedCatalogType || "catalog",
    category: "",
    subCategory: "",
    ipNetworkCategory: "",
    ipNetworkSubCategory: "",
    priceBase: "",
    discountedPrice: "",
    resellingPrice: "",
    gstPercentage: "",
    isTrending: false,
    warrantyDuration: "",
    warrantyUnit: "",
    description: "",
    features: [""],
    youtubeLink: [],
    specifications: [
      {
        title: "",
        details: "",
      },
    ],
    status: "draft",
    slug: "",
    metaTitle: "",
    metaDescription: "",
    metaTags: "",
    schemaScript: "",
  });

  const [productForm, setProductForm] = useState(getInitialProductForm());

  const [products, setProducts] = useState([]);

  const [images, setImages] = useState({
    existing: [],
    new: [],
    removed: [],
  });

  const [pdfs, setPdfs] = useState({
    existing: [],
    new: [],
    removed: [],
  });

  const [brands, setBrands] = useState([]);

  const [ipNetworkBrands, setIpNetworkBrands] = useState([]);

  const [categories, setCategories] = useState([]);

  const [subCategories, setSubCategories] = useState([]);

  const [ipNetworkCategories, setIpNetworkCategories] = useState([]);

  const [ipNetworkSubCategories, setIpNetworkSubCategories] = useState([]);

  const [loadingSub, setLoadingSub] = useState(false);

  const [totalProductCount, setTotalProductCount] = useState(null);

  const [totalBrandsCount, setTotalBrandsCount] = useState(null);

  const [totalCategoryCount, setTotalCategoryCount] = useState(null);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const [editId, setEditId] = useState(null);

  const [pagination, setPagination] = useState({
    page: 1,
    totalPages: 1,
    limit: 20,
  });

  const [search, setSearch] = useState("");

  const [filterOpen, setFilterOpen] = useState(false);

  const [filters, setFilters] = useState({
    brand: "",
    category: "",
  });

  const onEdit = async (item) => {
    setEditId(item._id);

    setProductForm({
      assetId: item.assetId || "",
      title: item.title || "",
      brand: item.brand?._id || "",
      ipNetworkBrand: item.ipNetworkBrand?._id || "",
      catalogType: lockedCatalogType || item.catalogType || "catalog",
      category: item.category?._id || "",
      subCategory: item.subCategory?._id || "",
      ipNetworkCategory: item.ipNetworkCategory?._id || "",
      ipNetworkSubCategory: item.ipNetworkSubCategory?._id || "",

      priceBase: item.priceBase || "",
      discountedPrice: item.discountedPrice || "",
      resellingPrice: item.resellingPrice || "",

      gstPercentage: item.gstPercentage || 18,

      isTrending: item.isTrending || false,

      warrantyDuration: item.warrantyDuration || "",
      warrantyUnit: item.warrantyUnit || "Year",

      description: item.description || "",

      features: item.features?.length ? item.features : [""],

      youtubeLink: item.youtubeLink?.length ? item.youtubeLink : [],

      specifications: item.specifications?.length
        ? item.specifications
        : [{ title: "", details: "" }],

      status: item.status || "draft",

      slug: item.slug || "",

      metaTitle: item.metaTitle || "",

      metaDescription: item.metaDescription || "",

      metaTags: Array.isArray(item.metaTags)
        ? item.metaTags.join(", ")
        : item.metaTags || "",
      schemaScript: item.schemaScript || "",
    });

    // LOAD SUBCATEGORY HERE
    if (item.catalogType === "ip-network" && item.ipNetworkCategory?._id) {
      try {
        setLoadingSub(true);
        const res = await http.get(
          `/ip-network/subcategories/by-category/${item.ipNetworkCategory._id}`,
          { params: { limit: 1000 } },
        );
        setIpNetworkSubCategories(res.data.subCategories || []);
      } catch (err) {
        setIpNetworkSubCategories([]);
      } finally {
        setLoadingSub(false);
      }
    } else if (item.category?._id) {
      try {
        setLoadingSub(true);

        const res = await http.get(
          `/subCategory/by-category/${item.category._id}?limit=1000`,
        );

        setSubCategories(res.data.subCategories || []);
      } catch (err) {
        console.log(err);
        setSubCategories([]);
      } finally {
        setLoadingSub(false);
      }
    }

    setImages({
      existing: item.images || [],
      new: [],
      removed: [],
    });

    setPdfs({
      existing: item.pdfs || [],
      new: [],
      removed: [],
    });

    setIsModalOpen(true);
  };

  const handleCategoryChange = async (id) => {
    setLoadingSub(true);

    setProductForm((prev) => ({
      ...prev,
      category: id,
      subCategory: "",
    }));

    try {
      const res = await http.get(`/subCategory/by-category/${id}`);

      setSubCategories(res.data.subCategories || []);
    } catch (err) {
      toast.error("Failed to load sub categories");
      setSubCategories([]);
    } finally {
      setLoadingSub(false);
    }
  };

  const handleIpNetworkCategoryChange = async (id) => {
    setLoadingSub(true);
    setProductForm((prev) => ({
      ...prev,
      ipNetworkCategory: id,
      ipNetworkSubCategory: "",
    }));
    try {
      const res = await http.get(`/ip-network/subcategories/by-category/${id}`);
      setIpNetworkSubCategories(res.data.subCategories || []);
    } catch (err) {
      toast.error("Failed to load IP Network sub categories");
      setIpNetworkSubCategories([]);
    } finally {
      setLoadingSub(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const requiredFields = {
      title: "Product title",
      assetId: "Asset ID",
      priceBase: "Base price",
      description: "Description",
    };

    for (const key in requiredFields) {
      const value = productForm[key];

      if (
        value === undefined ||
        value === null ||
        (typeof value === "string" && value.trim() === "")
      ) {
        toast.error(`${requiredFields[key]} is required`);
        return;
      }
    }

    if (productForm.catalogType === "ip-network") {
      if (!productForm.ipNetworkBrand) {
        toast.error("IT Product Brand is required");
        return;
      }
    } else if (!productForm.brand) {
      toast.error("Brand is required");
      return;
    }

    const categoryField =
      productForm.catalogType === "ip-network"
        ? productForm.ipNetworkCategory
        : productForm.category;
    if (!categoryField) {
      toast.error(
        productForm.catalogType === "ip-network"
          ? "IP Network category is required"
          : "Category is required",
      );
      return;
    }

    const taxonomyField =
      productForm.catalogType === "ip-network"
        ? productForm.ipNetworkSubCategory
        : productForm.subCategory;
    if (!taxonomyField) {
      toast.error("Product sub category is required");
      return;
    }
    if (!productForm.metaTitle?.trim()) {
      toast.error("Meta Title is required");
      return;
    }

    if (!productForm.metaDescription?.trim()) {
      toast.error("Meta Description is required");
      return;
    }

    if (!productForm.metaTags?.trim()) {
      toast.error("Meta Tags is required");
      return;
    }

    // IMAGE CHECK
    const hasImages =
      images.new.some((img) => img.file) || images.existing.length > 0;

    if (!hasImages) {
      toast.error("At least one product image is required");
      return;
    }

    // PDF CHECK
    const hasPdfs =
      pdfs.new.some((pdf) => pdf.file) || pdfs.existing.length > 0;

    if (!hasPdfs) {
      toast.error("At least one product PDF is required");
      return;
    }

    const formData = new FormData();

    Object.entries(productForm).forEach(([key, value]) => {
      if (value === "" || value === null || value === undefined) {
        return;
      }

      if (key === "metaTags") {
        const keywordArray = value
          .split(",")
          .map((k) => k.trim())
          .filter(Boolean);

        formData.append("metaTags", JSON.stringify(keywordArray));

        return;
      }

      if (key === "description" || key === "metaDescription") {
        formData.append(key, value);
        return;
      }

      if (Array.isArray(value) || typeof value === "object") {
        formData.append(key, JSON.stringify(value));
      } else {
        formData.append(key, typeof value === "string" ? value.trim() : value);
      }
    });

    if (images.new.length) {
      images.new.forEach((img) => {
        if (img.file) {
          formData.append("images", img.file);
        }
      });

      formData.append(
        "imageMeta",
        JSON.stringify(
          images.new.map((img, index) => ({
            alt: img.alt?.trim() || "",
            index,
          })),
        ),
      );
    }

    formData.append(
      "existingImages",
      JSON.stringify(
        images.existing.map((img, index) => ({
          id: img._id,
          url: img.url,
          alt: img.alt,
          index,
        })),
      ),
    );

    formData.append("removedImages", JSON.stringify(images.removed));

    if (pdfs.new.length) {
      pdfs.new.forEach((pdf) => {
        if (pdf.file) {
          formData.append("pdfs", pdf.file);
        }
      });

      formData.append(
        "pdfMeta",
        JSON.stringify(
          pdfs.new
            .filter((pdf) => pdf.file)
            .map((pdf, index) => ({
              name: pdf.name,
              index,
            })),
        ),
      );
    }

    formData.append(
      "existingPdfs",
      JSON.stringify(
        pdfs.existing.map((pdf, index) => ({
          id: pdf._id,
          url: pdf.url,
          name: pdf.name,
          index,
        })),
      ),
    );

    formData.append("removedPdfs", JSON.stringify(pdfs.removed));

    try {
      if (editId) {
        await http.put(`/products/${editId}`, formData);
        toast.success("Product updated successfully");
      } else {
        await http.post("/products", formData);
        toast.success("Product created successfully");
      }
      resetProductForm();
      await loadProducts(pagination.page);
      setIsModalOpen(false);
    } catch (err) {
      console.log(err);

      toast.error(err.response?.data?.message || "Failed to create product");
    }
  };

  const fetchBrandData = async () => {
    try {
      if (brands.length > 0) {
        return;
      }

      const res = await http.get("/brands?limit=1000");

      setBrands(res.data.brands || []);
      setTotalBrandsCount(res.data.total);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchCategoryData = async () => {
    try {
      if (categories.length > 0) {
        return;
      }
      const res = await http.get("/category?limit=1000");

      setCategories(res.data.category || []);
      setTotalCategoryCount(res.data.total);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchAllSubCategories = async () => {
    try {
      const res = await http.get("/subCategory?limit=1000");
      setSubCategories(res.data.subCategories || []);
    } catch (error) {
      console.log("fetchAllSubCategories error", error);
      setSubCategories([]);
    }
  };

  const fetchIpNetworkCategories = async () => {
    try {
      const res = await http.get("/ip-network/categories", {
        params: { limit: 1000 },
      });
      setIpNetworkCategories(res.data.categories || []);
    } catch (error) {
      console.log("fetchIpNetworkCategories error", error);
      setIpNetworkCategories([]);
    }
  };

  const fetchIpNetworkBrands = async () => {
    try {
      if (ipNetworkBrands.length > 0) {
        return;
      }
      const res = await http.get("/ip-network/brands", { params: { limit: 1000 } });
      setIpNetworkBrands(res.data.brands || []);
    } catch (error) {
      console.log("fetchIpNetworkBrands error", error);
      setIpNetworkBrands([]);
    }
  };

  const closeModal = () => {
    resetProductForm();
    setIsModalOpen(false);
  };

  const resetProductForm = () => {
    setEditId(null);

    setProductForm(getInitialProductForm());

    setImages({
      existing: [],
      new: [],
      removed: [],
    });

    setPdfs({
      existing: [],
      new: [],
      removed: [],
    });

    // preload all subcategories so the dropdown shows options even before a category is selected
    fetchAllSubCategories();
  };

  const loadProducts = async (page = pagination.page) => {
    try {
      const params = new URLSearchParams({
        page,
        limit: pagination.limit,
      });

      if (search) {
        params.append("search", search);
      }

      if (filters.brand) {
        params.append("brand", filters.brand);
      }

      if (filters.category) {
        params.append("category", filters.category);
      }

      if (lockedCatalogType) {
        params.append("catalogType", lockedCatalogType);
      }

      const res = await http.get(`/products?${params.toString()}`);

      setProducts(res.data.product || []);
      setTotalProductCount(res.data.total);

      setPagination((prev) => ({
        ...prev,
        page,
        totalPages: res.data.totalPages || 1,
      }));
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchBrandData();
    fetchCategoryData();
    fetchIpNetworkCategories();
    fetchIpNetworkBrands();
  }, []);

  //need to update this
  useEffect(() => {
    loadProducts(pagination.page);
  }, [pagination.page, pagination.limit]);
  const debouncedSearch = useDebounce(search, 500);

  useEffect(() => {
    loadProducts(1);
  }, [debouncedSearch, filters.brand, filters.category]);

  useEffect(() => {
    return () => {
      images.new.forEach((img) => URL.revokeObjectURL(img.preview));
    };
  }, []);

  const filterBrandOptions = useMemo(
    () => [
      { value: "", label: "All Brands" },
      ...brands.map((brand) => ({
        value: brand._id,
        label: brand.brandName,
      })),
    ],
    [brands],
  );

  const filterCategoryOptions = useMemo(
    () => [
      { value: "", label: "All Categories" },
      ...categories.map((category) => ({
        value: category._id,
        label: category.name,
      })),
    ],
    [categories],
  );

  return (
    <div className="p-4 md:p-8 min-h-screen text-slate-200 ">
      <AdminHeader
        title={lockedCatalogType === "ip-network" ? "IT Products" : "Products"}
        buttonText={lockedCatalogType === "ip-network" ? "Add IT Product" : "Add Product"}
        onClick={() => {
          resetProductForm();
          setIsModalOpen(true);
        }}
      />

      <div className="flex flex-col md:flex-row w-full mb-8  gap-4">
        <StatCard
          title={lockedCatalogType === "ip-network" ? "Total IT Products" : "Total Products"}
          count={totalProductCount}
          icon={Package}
        />
        <StatCard
          title="Total Brands"
          count={totalBrandsCount}
          icon={Package}
        />
        <StatCard
          title="Total Categories"
          count={totalCategoryCount}
          icon={Package}
        />
      </div>
      <div className="flex flex-col md:flex-row gap-4 mb-6">
        <div className="flex-1 relative">
          <Search
            size={18}
            className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400"
          />

          <input
            placeholder="Search product..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="
w-full
pl-10
px-4
py-3
rounded-xl
bg-white/5
border
border-white/10
text-white
outline-none
"
          />
        </div>

        <button
          onClick={() => setFilterOpen(true)}
          className="
px-5
py-3
rounded-xl
bg-blue-600
text-white
flex
gap-2
items-center
"
        >
          <Filter size={18} />
          Filters
        </button>
      </div>
      {products.length === 0 ? (
        <div className="p-8 rounded-2xl bg-white/5 border border-white/10 text-center text-slate-400">
          No products found
        </div>
      ) : (
        <div className="space-y-3">
          {products.map((item) => (
            <div
              key={item._id}
              className="
        group
        flex
        flex-col
        lg:flex-row
        lg:items-center
        justify-between
        gap-4
        p-4
        rounded-2xl
        bg-slate-900/40
        border border-slate-800
        hover:border-slate-700
        hover:bg-slate-900/60
        transition-all
      "
            >
              {/* LEFT: Product Info */}
              <div className="flex items-center gap-4 flex-1 min-w-0">
                {/* Image */}
                <div className="h-14 w-14 rounded-xl bg-slate-800 flex items-center justify-center overflow-hidden shrink-0">
                  {item.images?.length ? (
                    <img
                      src={GetImageUrl(item.images[0]?.url)}
                      className="h-full w-full object-cover"
                      alt={item.title}
                    />
                  ) : (
                    <Package size={22} className="text-slate-400" />
                  )}
                </div>

                {/* Content */}
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2">
                    <h3 className="text-white font-semibold text-sm lg:text-base truncate">
                      {item.title}
                    </h3>

                    <span
                      className={`
                text-[10px] px-2 py-0.5 rounded-full
                ${
                  item.status === "published"
                    ? "bg-emerald-500/15 text-emerald-400"
                    : "bg-yellow-500/15 text-yellow-400"
                }
              `}
                    >
                      {item.status}
                    </span>
                  </div>

                  {/* Meta */}
                  <div className="mt-1 flex flex-wrap gap-x-4 gap-y-1 text-[11px] text-slate-400">
                    <span>
                      Brand:{" "}
                      <span className="text-slate-200">
                        {item.brand?.brandName || "N/A"}
                      </span>
                    </span>

                    <span>
                      Category:{" "}
                      <span className="text-slate-200">
                        {item.category?.name || "N/A"}
                      </span>
                    </span>

                    <span>
                      Sub:{" "}
                      <span className="text-slate-200">
                        {item.subCategory?.name || "N/A"}
                      </span>
                    </span>
                  </div>
                </div>
              </div>

              {/* RIGHT: Actions */}
              <div className="flex items-center justify-end gap-2 ">
                <ActionButtons
                  onEdit={() => onEdit(item)}
                  onDelete={async () => {
                    if (!confirm("Delete this product?")) return;

                    try {
                      await http.delete(`/products/delete/${item._id}`);
                      toast.success("Product deleted");
                      await loadProducts(pagination?.page);
                    } catch (err) {
                      toast.error("Delete failed");
                    }
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      )}
      {products.length > 0 && (
        <div
          className="
      flex
      flex-col sm:flex-row
      justify-center
      items-center
      gap-3 sm:gap-4
      mt-8
      px-2
    "
        >
          <button
            disabled={pagination?.page === 1}
            onClick={() =>
              setPagination((p) => ({
                ...p,
                page: p.page - 1,
              }))
            }
            className="
        w-full sm:w-auto
        px-4 sm:px-5
        py-2
        rounded-xl
        bg-white/10
        hover:bg-white/20
        disabled:opacity-40
        transition
        text-sm sm:text-base
      "
          >
            Previous
          </button>

          <span
            className="
        text-white
        text-sm sm:text-base
        whitespace-nowrap
      "
          >
            Page {pagination?.page} of {pagination?.totalPages}
          </span>

          <button
            disabled={
              !pagination.totalPages ||
              pagination?.page === pagination?.totalPages
            }
            onClick={() =>
              setPagination((p) => ({
                ...p,
                page: p.page + 1,
              }))
            }
            className="
        w-full sm:w-auto
        px-4 sm:px-5
        py-2
        rounded-xl
        bg-blue-600
        hover:bg-blue-700
        disabled:opacity-40
        transition
        text-sm sm:text-base
      "
          >
            Next
          </button>
        </div>
      )}
      <AnimatePresence>
        {isModalOpen && (
          <CreateProduct
            handleSubmit={handleSubmit}
            closeModal={closeModal}
            images={images}
            setImages={setImages}
            pdfs={pdfs}
            setPdfs={setPdfs}
            productForm={productForm}
            setProductForm={setProductForm}
            brands={brands}
            ipNetworkBrands={ipNetworkBrands}
            categories={categories}
            subCategories={subCategories}
            ipNetworkCategories={ipNetworkCategories}
            ipNetworkSubCategories={ipNetworkSubCategories}
            handleCategoryChange={handleCategoryChange}
            handleIpNetworkCategoryChange={handleIpNetworkCategoryChange}
            loadingSub={loadingSub}
            lockedCatalogType={lockedCatalogType}
          />
        )}
      </AnimatePresence>
      <AnimatePresence>
        {filterOpen && (
          <motion.div
            className="
fixed inset-0
bg-black/70
z-50
flex
items-center
justify-center
"
          >
            <motion.div
              className="
bg-[#0a0f1a]
border border-white/10
rounded-2xl
p-6
w-[90%]
max-w-md
"
            >
              <h2 className="text-white text-xl font-bold mb-5">
                Filter Products
              </h2>

              <div className="space-y-5">
                <FormSelect
                  label="Brand"
                  value={filters.brand}
                  className="w-full border border-white/10 bg-white/5 text-white px-4 py-3 rounded-xl outline-none focus:border-blue-500 transition"
                  onChange={(e) =>
                    setFilters((prev) => ({
                      ...prev,
                      brand: e.target.value,
                    }))
                  }
                  options={filterBrandOptions}
                />

                <FormSelect
                  label="Category"
                  className="w-full border border-white/10 bg-white/5 text-white px-4 py-3 rounded-xl outline-none focus:border-blue-500 transition"
                  value={filters.category}
                  onChange={(e) =>
                    setFilters((prev) => ({
                      ...prev,
                      category: e.target.value,
                    }))
                  }
                  options={filterCategoryOptions}
                />
              </div>

              <div className="flex gap-3 mt-6">
                <button
                  onClick={() => {
                    setFilters({
                      brand: "",
                      category: "",
                    });

                    setFilterOpen(false);
                  }}
                  className="
flex-1
bg-white/10
text-white
p-3
rounded-xl
"
                >
                  Clear
                </button>

                <button
                  onClick={() => setFilterOpen(false)}
                  className="
flex-1
bg-blue-600
text-white
p-3
rounded-xl
"
                >
                  Apply
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default AdminProducts;
